<template>
  <Modal id="OtherDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('other.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('other.field.id_oth')">{{data.idOth}}</DescriptionsItem>
      <DescriptionsItem :label="$t('other.field.id_pay')">{{data.idPay}}</DescriptionsItem>
      <DescriptionsItem :label="$t('other.field.id_sub')">{{data.subjectSubjectNameHk}}</DescriptionsItem>
      <DescriptionsItem :label="$t('other.field.id_adv')">{{data.advisorName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('other.field.other_amount')">{{data.otherAmount}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "OtherDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>